import { render, staticRenderFns } from "./UpdateShippedDialogV2.vue?vue&type=template&id=70d9cca4&scoped=true&lang=pug&"
import script from "./UpdateShippedDialogV2.vue?vue&type=script&lang=ts&"
export * from "./UpdateShippedDialogV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9cca4",
  null
  
)

export default component.exports